
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import 'swiper/css/swiper.css';
import {
  Product,
} from '~/node_modules/sitisjs/dist/internal/sections/products/models/Product';

export default BaseCmsBlock.extend({
  name: 'FilterPageBlock',

  data: function () {
    const vnode = (Math.random() + 1).toString(36).substring(7);

    return {
      products: (this.extras?.products || []).map((t) => new Product(t)),

      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 1.2,
        slidesPerGroup: 1,

        navigation: {
          prevEl: `#button-navigation-${vnode}-prev`,
          nextEl: `#button-navigation-${vnode}-next`,
        },
        breakpoints: {
          1200: {
            spaceBetween: 30,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          860: {
            spaceBetween: 10,
            slidesPerView: 2.8,
            slidesPerGroup: 1,
          },
          640: {
            spaceBetween: 10,
            slidesPerView: 2.2,
            slidesPerGroup: 1,
          },
        },
      },

      vnode,
    };
  },

  components: {
    Swiper,
    SwiperSlide,

    ProductCard: () => import('~/components/catalog/ProductCard'),
  },
});
